import { createSlice } from '@reduxjs/toolkit';
import initialState from './qualityAssuranceInitialState';

export const qualityAssuranceSlice = createSlice({
  name: 'qualityAssurance',
  initialState,
  reducers: {
    qualityAssurance: (state, action) => {
      state.qualityAssuranceList = action.payload;
    },
  },
});

export const { qualityAssurance } = qualityAssuranceSlice.actions;

export default qualityAssuranceSlice.reducer;
